export default {
  title: 'PayPal (direct)',
  description:
    'Connectez votre propre compte PayPal professionnel pour encaisser les paiements PayPal directement, à votre propre taux. Créez une application REST dans le tableau de bord développeur PayPal et collez son Client ID et son Secret ci-dessous.',
  connected_description: 'Votre compte PayPal est connecté. Les paiements seront versés directement dessus.',
  guide: {
    title: 'Comment obtenir vos identifiants PayPal',
    step1: 'Connectez-vous au tableau de bord développeur PayPal avec votre compte PayPal professionnel.',
    step2: 'Ouvrez « Apps & Credentials » et créez une application (ou ouvrez la vôtre).',
    step3: "Copiez le Client ID et le Secret de l'application.",
    step4: 'Collez-les ci-dessous et cliquez sur « Connecter PayPal ».',
    environment_note:
      'Utilisez vos identifiants Live pour les paiements réels — activez le bouton Sandbox/Live en haut de « Apps & Credentials ».',
    open_dashboard: 'Ouvrir le tableau de bord développeur PayPal',
  },
  status: {
    connected: 'Connecté',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID de votre application REST PayPal',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret de votre application REST PayPal',
    },
  },
  buttons: {
    connect: 'Connecter PayPal',
    disconnect: 'Déconnecter',
  },
  toasts: {
    connected: 'PayPal connecté avec succès',
    connect_failed: 'Impossible de connecter PayPal',
    disconnected: 'PayPal déconnecté',
    disconnect_failed: 'Impossible de déconnecter PayPal',
  },
};
